<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.tableFilterDialog_title | titlecase}}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" mat-dialog-close [aria-label]="data.sysText.cancel">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form [formGroup]="form">
    @if (data.tableFilterOptions.showCompanies) {
      <app-select-field
        class="field"
        [icon]="'business'"
        [control]="company"
        [label]="data.sysText.company"
        [options]="data.tableFilterOptions.companies"
        [shouldCapitalize]="false"
        [showBlankOption]="true">
      </app-select-field>
    }
    <div class="container">
      <mat-icon [ngClass]="{ focus: select.focused }">location_on</mat-icon>
      <mat-form-field color="accent">
        <mat-label>{{ data.sysText.location | titlecase }}</mat-label>
        <mat-select
          #select="matSelect"
          [formControl]="location"
          [compareWith]="compareWith"
          disableOptionCentering
          panelClass="dropDownSelect"
          panelWidth="fit-content">
          <mat-select-trigger>
            {{ $safeNavigationMigration(location.value?.id) | findfromid: locationOptions }}
          </mat-select-trigger>
          @if (locationOptions.length > 0) {
            <mat-option [value]="null"></mat-option>
          }
          @for (option of locationOptions; track option) {
            <mat-option [value]="option">
              <span>{{ option.description }}</span>
              <span class="caption option-info">{{option.optionInfo}}</span>
            </mat-option>
          }
        </mat-select>
        <!-- mat hint for spacing -->
        <mat-hint></mat-hint>
      </mat-form-field>
    </div>
    <app-select-field
      class="field"
      [icon]="'assignment_turned_in'"
      [control]="leaveType"
      [label]="data.sysText.leaveType"
      [options]="data.tableFilterOptions.leaveTypes"
      [shouldCapitalize]="false"
      [showBlankOption]="true">
    </app-select-field>
    <app-select-field
      class="field"
      [icon]="'format_list_bulleted'"
      [control]="stage"
      [label]="data.sysText.stage"
      [options]="data.tableFilterOptions.stages"
      [shouldCapitalize]="false"
      [showBlankOption]="true">
    </app-select-field>
    <app-autocomplete-field
      [icon]="'person'"
      [label]="data.sysText.administrator"
      [control]="admin"
      [options]="data.tableFilterOptions.admins"
      [showSearchIcon]="false"
      [showImage]="true">
    </app-autocomplete-field>
    @if (data.tableFilterOptions.showActionNeeded) {
      <div class="container">
        <mat-icon [ngClass]="{ focus: select.focused }">error_outline</mat-icon>
        <mat-form-field color="accent">
          <mat-label>{{ data.sysText.actionNeeded | titlecase }}</mat-label>
          <mat-select #select="matSelect" [formControl]="actionNeeded" disableOptionCentering panelClass="dropDownSelect" panelWidth="fit-content">
            <mat-select-trigger>
              {{ data.sysText['actionNeededOptions_' + actionNeeded.value] }}
            </mat-select-trigger>
            <mat-option [value]="null"></mat-option>
            @for (option of actionNeededOptions; track option) {
              <mat-option [value]="option.id">
                <span>{{ option.description }}
                  <app-status-chip
								[icon]="option.id == actionNeededTypes.NeedsAction ? 'error_outline' 
									: option.id == actionNeededTypes.DocumentNeeded ? 'upload' 
									: option.id == actionNeededTypes.BeAdvised ? 'warning_amber'
									: 'youtube_searched_for'"
								[ngStyle]="(option.id == actionNeededTypes.NeedsAction || option.id == actionNeededTypes.DocumentNeeded) ? chipStyles.warnBg 
									: option.id == actionNeededTypes.BeAdvised ? chipStyles.warnYelBg 
									: chipStyles.inProgBg">
                  </app-status-chip>
                </span>
              </mat-option>
            }
          </mat-select>
          <!-- mat hint for spacing -->
          <mat-hint></mat-hint>
        </mat-form-field>
      </div>
    }
    @if (data.showHideCaseFeatures) {
      <div class="toggle--section">
        <app-slide-toggle
          [icon]="'visibility'"
          [control]="showHidden"
          [label]="data.sysText.showHiddenFilter">
        </app-slide-toggle>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions class="space-between">
  <button mat-stroked-button class="button" color="accent" (click)="onClearFilters()">
    {{ data.sysText.clearFilters | uppercase}}
  </button>
  <div>
    @if (!(isMobile$ | async)) {
      <button mat-stroked-button mat-dialog-close class="button" color="accent">
        {{ data.sysText.cancel | uppercase}}
      </button>
    }
    <button mat-stroked-button class="button" color="accent" (click)="onApply()">
      {{ data.sysText.apply | uppercase}}
    </button>
  </div>
</mat-dialog-actions>